const state= {
    Items:{
        data:[],
        total:0,
    },
};

const getters = {
    Items : (state) => state.Items,
};

const actions = {
    //Items
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/import-logs`, {params:params})
                .then(response => {
                    commit('setItems', response.data.data);
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setItems (state,data) {
        state.Items.data = data.items;
        state.Items.total = data.total;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}